import type { AuthOnboardingState, AuthOnboardingValues } from './types';

export const EMPTY_FIELD_VALUES: AuthOnboardingValues = {
  allowEmailMarketing: null,
  allInGender: null,
  biometricLiveness: undefined,
  birthDate: '',
  consents: null,
  customGender: null,
  displaySexualOrientations: null,
  displayGenders: null,
  email: '',
  gender: null,
  interestedInGender: null,
  interestedInGenders: null,
  name: '',
  photos: null,
  relationshipIntent: null,
  sexualOrientations: null,
  showGenderOnProfile: false,
  showOrientationOnProfile: false,
  showSameOrientationFirst: null,
  tinderRules: null,
  userInterests: null,
};

const initialState: AuthOnboardingState = {
  consents: {},
  currentStep: null,
  editableFields: {},
  erroredFields: {},
  initialValues: EMPTY_FIELD_VALUES,
  isCompleted: false,
  isInitialized: false,
  isLoading: false,
  isReactivated: false,
  hasRedactedEnabled: null,
  isUnderage: null,
  queuedPhotos: [],
  requiredFields: {},
  steps: [],
  values: EMPTY_FIELD_VALUES,
};

export default initialState;
